<template>
	<section>
		<v-alert type="success" dismissible v-show="alert_success">
		You're all set!  Please see the instructions below for setting up your meeting app.
		</v-alert>
		<v-alert type="error" dismissible v-show="alert_error">
		We were unable to access your camera - please contact support.
		</v-alert>
		<div v-if="camera_permission_needed" style="width: 50%; margin: 0 auto">
			<h2>Please grant permission to your camera so that lighty can start whenever you're on a video call.</h2>
			<v-progress-circular
			v-if="loading"
			id="loading_spinner"
			indeterminate
			size=64
			color="primary"
			>
			</v-progress-circular>
		</div>
		<div v-if="show_free_trial_prompt" style="width: 50%; margin: 0 auto">
			<h2>Enjoy the free trial of lighty for 1 week.  You can <router-link :to="'/subscription'">upgrade</router-link> to get more filters & better video quality.</h2>
		</div>
		<iframe id="setup_instructions" src="https://www.lighty.app/help/setup" v-show="show_setup_instructions"></iframe>
	</section>
</template>

<script>
export default {
  props: ['user', 'api_prefix', 'subscription_plan'],
  data: function () {
  return {
    loading: false,
	camera_permission_needed: false,
	show_free_trial_prompt: false,
	alert_error: false,
	show_setup_instructions: false,
	alert_success: false
    }
  },
  created: function()
  {
	let self = this;
    navigator.permissions.query({ name: "camera" }).then(res => 
	{
		if(res.state == "granted")
		{
			self.alert_success = true;
			localStorage.setItem('installation_completed', 'true');
			self.show_setup_instructions = true;
			self.camera_permission_needed = false;
			if(self.subscription_plan=='free')
			{
				self.show_free_trial_prompt = true;
			}
		}
		else
		{
			self.camera_permission_needed = true;

			var constraints = { video: true };

			navigator.mediaDevices.getUserMedia(constraints).then(function(mediaStream)
			{
				self.alert_success = true;
				self.show_setup_instructions = true;
				self.camera_permission_needed = false;
				if(self.subscription_plan=='free')
				{
					self.show_free_trial_prompt = true;
				}
			})
			.catch(function(err)
			{
				self.alert_error = true;
				window.analytics.track("Camera Permissions Error", {
					type: err.name,
					message: err.message
				});
				console.log(err.name + ": " + err.message);
			});
		}
	});
  },
	mounted: function() 
	{
		window.analytics.page('Install');
	},
	methods: 
	{

	}
}
</script>

<style scoped>
#setup_instructions
{
	height: 750px;
	width: 100%;
	border: 0px;
}
</style>
